/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionSpotlightModule_componentModule = {
    readonly messages: {
        readonly title: string | null;
        readonly description: string | null;
        readonly isCollection: boolean | null;
        readonly videoEmbedId: string | null;
        readonly linkText: string | null;
        readonly cta: string | null;
        readonly collectionImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly collectionPhoneImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly profileImage: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly image: {
            readonly imageUrl: string | null;
            readonly imageWidth: string | null;
            readonly imageHeight: string | null;
        } | null;
        readonly linkData: {
            readonly path: string | null;
            readonly " $fragmentRefs": FragmentRefs<"SeoButton_linkData">;
        };
        readonly items: ReadonlyArray<{
            readonly title: string | null;
            readonly itemId: string | null;
            readonly contemporaryTrackingString: string | null;
            readonly linkData: {
                readonly path: string | null;
            };
            readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightItem_item">;
        } | null> | null;
    } | null;
    readonly " $refType": "HpRespCollectionSpotlightModule_componentModule";
};
export type HpRespCollectionSpotlightModule_componentModule$data = HpRespCollectionSpotlightModule_componentModule;
export type HpRespCollectionSpotlightModule_componentModule$key = {
    readonly " $data"?: HpRespCollectionSpotlightModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionSpotlightModule_componentModule">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageUrl",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageWidth",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "imageHeight",
    "storageKey": null
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userType"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespCollectionSpotlightModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userType",
          "variableName": "userType"
        }
      ],
      "concreteType": "CollectionSpotlightItemMessages",
      "kind": "LinkedField",
      "name": "messages",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isCollection",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoEmbedId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "linkText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cta",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "kind": "LinkedField",
          "name": "collectionImage",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "kind": "LinkedField",
          "name": "collectionPhoneImage",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "kind": "LinkedField",
          "name": "profileImage",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionSpotlightImageType",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoButton_linkData"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CollectionSpotlightItem",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "itemId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contemporaryTrackingString",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkData",
              "kind": "LinkedField",
              "name": "linkData",
              "plural": false,
              "selections": [
                (v2/*: any*/)
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "HpRespCollectionSpotlightItem_item"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CollectionSpotlightModule",
  "abstractKey": null
};
})();
(node as any).hash = '2923231f5d393e0bd74cf108178f5610';
export default node;
